import { withCloseAfterExited } from "../modal";
import {
  default as View,
  SuspendUserModalProps
} from "./suspend-user-modal-view";

const SuspendUserModal = withCloseAfterExited<SuspendUserModalProps>(View);
export default SuspendUserModal;
